module.exports = __webpack_public_path__ + "/images/ico-color-gratis.0576d70.svg";